import { render, staticRenderFns } from "./EndorsementList.vue?vue&type=template&id=245d9aca"
import script from "./EndorsementList.vue?vue&type=script&lang=js"
export * from "./EndorsementList.vue?vue&type=script&lang=js"
import style0 from "./EndorsementList.vue?vue&type=style&index=0&id=245d9aca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports